import { render, staticRenderFns } from "./houseInput.vue?vue&type=template&id=48956808&"
import script from "./houseInput.vue?vue&type=script&lang=js&"
export * from "./houseInput.vue?vue&type=script&lang=js&"
import style0 from "./houseInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports